/**
 * Vuex 4 Store Services Plugin
 *
 * In Vuex 3, store actions could access Vue instance properties via `this._vm.$xxx`.
 * In Vuex 4, `this._vm` no longer exists. This plugin injects shared service
 * instances directly onto the store, so actions can use `this.$xxx` instead.
 *
 * Must be initialized after the app is created by calling `injectServices(store, services)`.
 */

export function injectServices(store, services) {
	Object.keys(services).forEach((key) => {
		store[key] = services[key];
	});
}

// eslint-disable-next-line no-unused-vars
export default function servicesPlugin(store) {
	// Services are injected later via injectServices() after the app is created.
	// This plugin placeholder ensures the store is aware of the plugin.
}
